import { z } from "zod";

export const zServFunc = z.object({
  functionName: z.string(),
  active: z.boolean(),
  displayFunctionName: z.string().nullable(),
});

export type ZServFunc = z.infer<typeof zServFunc>;
